import { gql, TypedDocumentNode } from '@apollo/client';
import {
  DefaultApiResponse,
  DefaultArg,
  transactionErrorFragment,
} from '@libs/graphql';

import { CurrencyType, WithdrawalMethods } from '@libs/types';
import { TransactionErrorResponse } from 'src/types';

export type CalculatedWithdrawal = {
  fee: number;
  feeRate?: number;
  totalAmount: number;
  remainingAmount: number;
  valueInGivenFiat?: number;
  error?: TransactionErrorResponse;
};

export type CalculateWithdrawalArgs = {
  amount: number;
  assetCode: string;
  method: WithdrawalMethods;

  iban?: string;
  fireblocksId?: string;
  walletAddress?: string;
  givenFiat?: CurrencyType.GEL | CurrencyType.USD;
};

export type CalculateWithdrawalResponse = {
  calculateWithdrawalValues: DefaultApiResponse<CalculatedWithdrawal>;
};

export const calculateWithdrawalValuesQuery: TypedDocumentNode<
  CalculateWithdrawalResponse,
  DefaultArg<CalculateWithdrawalArgs>
> = gql`
  query CalculateWithdrawalValues($record: CalculateWithdrawalValuesRecord!) {
    calculateWithdrawalValues(record: $record) {
      fee
      feeRate
      totalAmount
      remainingAmount
      valueInGivenFiat
      error {
        ...transactionErrorFields
      }
    }
  }
  ${transactionErrorFragment}
`;
